import React from 'react'
import { func } from 'prop-types'
import DefaultComponentLayout, { LayoutContent } from '../../../common/Layout'
import Confirm from '../../../common/Confirm'
import I18nMessage from '../../../common/I18nMessage'

const trackInfo = {
  eventName: 'ResetPasswordConfirm',
  widget: 'reset_confirm',
  pageType: 'reset password confirm',
}

function ResetPWDConfirm(props) {
  const { Header } = props
  return (
    <DefaultComponentLayout nameSpace="passport__resetPassword__confirm" Header={Header}>
      <LayoutContent title message="passport.resetPassword.confirm.title" />
      <LayoutContent main>
        <div className="passport__resetPassword__confirm-notice text-font-18 font-weight-600">
          <I18nMessage id="passport.resetPassword.notice.success" />
        </div>
        <Confirm {...props} trackInfo={trackInfo} />
      </LayoutContent>
    </DefaultComponentLayout>
  )
}

ResetPWDConfirm.propTypes = {
  Header: func,
}

ResetPWDConfirm.defaultProps = {
  Header: null,
}
export default ResetPWDConfirm
